export default {
  CACHE_IDV_TOKEN: 'idv_token',
  CHECKOUT_QUERY: 'checkout_query',
}
